import React, { Fragment } from "react";
import { withStyles } from "material-ui/styles";
import TotalResultByAttributes from "components/ReportDetail/TotalResultByAttributes.jsx";
import ErrorMessage from "components/ErrorMessage";
import CircularProgress from "material-ui/Progress/CircularProgress";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100
  },
  reportTitle: { fontSize: 30, textAlign: "center" },
  chapter: {
    paddingTop: 70,
    paddingLeft: 20
  },
  chapterTitle: {
    fontSize: 20,
    fontWeight: 600,
    textAlign: "center"
  },
  section: {
    paddingLeft: 20
  },
  sectionTitle: {
    fontWeight: 600,
    display: "inline-block"
  },
  result: {
    marginBottom: 50
  },
  errorMessage: {
    margin: 10
  }
});

const makeGraph = (data, classes) => (
  <Fragment key={data.title}>
    <div className={classes.result}>
      <span className={classes.sectionTitle} style={{ marginLeft: "2rem" }}>
        Q{data.qNo}
      </span>
      <span className={classes.sectionTitle} style={{ marginLeft: "1rem" }}>
        {data.text}
      </span>
      <TotalResultByAttributes
        data={data.data}
        xCategories={data.xCategories}
      />
    </div>
  </Fragment>
);

class OriginalReport extends React.Component {
  componentWillMount() {
    this.props.fetchOriginalReport();
  }
  componentWillUnmount() {
    this.props.initOriginalReport();
  }
  render() {
    const { classes, originalReport } = this.props;
    const { originalQuestion, errors } = originalReport;
    if (errors.length > 0) {
      return (
        <ErrorMessage messages={errors} className={classes.errorMessage} />
      );
    }
    if (originalQuestion.length === 0) {
      return (
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 100 }}
        >
          <CircularProgress size={100} />
        </div>
      );
    }
    return (
      <div style={{ padding: 30, backgroundColor: "white" }}>
        <div className={classes.reportTitle}>
          NiserES 調査結果 添付資料【追加設問】
        </div>
        {/* 属性別集計結果 */}
        <section className={classes.chapter} id="summary">
          <div className={classes.chapterTitle}>属性別集計結果</div>
          {originalQuestion.map(v => makeGraph(v, classes))}
        </section>
      </div>
    );
  }
}

export default withStyles(styles)(OriginalReport);



// WEBPACK FOOTER //
// ./src/components/ReportDetail/OriginalReport.jsx